import qs from 'qs';
import { api } from 'api/api';
import { InvoiceResponseViewModel } from 'types/invoice';
import { GetInvoicesRequest, UpdateInvoiceRequest, CreateInvoiceRequest, InvoicesResponse } from './types';
import { parametrizeURL } from 'api/utils';

export const INVOICE_URL = 'Invoice' as const;
export const GET_INVOICES_URL = `${INVOICE_URL}/GetAllAsync` as const;
export const ADD_INVOICE_URL = `${INVOICE_URL}/AddAsync` as const;
export const ESTIMATE_INVOICE_URL = `${INVOICE_URL}/EstimateAsync` as const;
export const ADD_INVOICE_WITHOUT_SQUARE_URL = `${INVOICE_URL}/AddWithoutSquareAsync` as const;
export const GENERATE_EMAIL_ESTIMATE_INVOICE_URL = `${INVOICE_URL}/GenerateEmailEstimateAsync` as const;
export const UPDATE_INVOICE_URL = `${INVOICE_URL}/UpdateAsync/{InvoiceId}` as const;

export const readInvoiceById = (params: { id: string }) => api.get<InvoiceResponseViewModel>(INVOICE_URL, { params });

export const deleteInvoiceById = (data: { id: string }) => api.delete<void>(INVOICE_URL, { data });

export const readInvoices = (params: GetInvoicesRequest) =>
    api.get<InvoicesResponse>(GET_INVOICES_URL, {
        params,
        paramsSerializer: (param) => qs.stringify(param, { arrayFormat: 'repeat' }),
    });

export const createInvoice = (body: CreateInvoiceRequest) => api.post<InvoiceResponseViewModel>(ADD_INVOICE_URL, body);

export const createInvoiceWithoutSquare = (body: CreateInvoiceRequest) =>
    api.post<InvoiceResponseViewModel>(ADD_INVOICE_WITHOUT_SQUARE_URL, body);

export const estimateInvoice = (body: { appointmentId: string }) =>
    api.post<InvoiceResponseViewModel>(ESTIMATE_INVOICE_URL, body);

export const generateEmailEstimateInvoice = (body: CreateInvoiceRequest, asAppointmentUser: boolean) =>
    api.post<InvoiceResponseViewModel>(GENERATE_EMAIL_ESTIMATE_INVOICE_URL, body, { params: { asAppointmentUser } });

export const replaceInvoice = (body: UpdateInvoiceRequest, InvoiceId: string) =>
    api.post<InvoiceResponseViewModel>(parametrizeURL(UPDATE_INVOICE_URL, { InvoiceId: InvoiceId }), body);
